import React from "react";
import ErrorPage from "./ErrorPage";

// Fallback for errors outside the router, where there is no router to navigate with,
// so Go Home reloads the app at its home page
const CustomErrorBoundary = ({ error }) => (
  <ErrorPage error={error} onGoHome={() => window.location.assign("/")} />
);

export default CustomErrorBoundary;
